<template>
  <teleport to="body">
    <div class="toast-stack" aria-live="polite">
      <transition-group name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          :class="['toast', `toast--${toast.type}`]"
        >
          <span class="toast-icon">
            <span v-if="toast.type === 'success'">&#10003;</span>
            <span v-else-if="toast.type === 'error'">&#10005;</span>
            <span v-else class="toast-spinner"></span>
          </span>
          <span class="toast-message">{{ toast.message }}</span>
          <button class="toast-close" aria-label="Dismiss" @click="dismiss(toast.id)">&#x2715;</button>
        </div>
      </transition-group>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { useToast } from "@/use/useToast";

const { toasts, dismiss } = useToast();
</script>

<style scoped>
.toast-stack {
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 9999;
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 260px;
  max-width: 380px;
  padding: 12px 14px;
  border-radius: 6px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  color: #fff;
  pointer-events: all;
}

.toast--info    { background: #1a4d8f; }
.toast--success { background: #2f8a5b; }
.toast--error   { background: #b00020; }

.toast-icon {
  flex-shrink: 0;
  font-size: 14px;
  line-height: 1;
}

.toast-spinner {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  vertical-align: middle;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.toast-message {
  flex: 1;
}

.toast-close {
  flex-shrink: 0;
  background: none;
  border: none;
  color: rgba(255,255,255,0.8);
  cursor: pointer;
  font-size: 13px;
  padding: 0 2px;
  line-height: 1;
}

.toast-close:hover {
  color: #fff;
}

.toast-enter-active,
.toast-leave-active {
  transition: all 0.25s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateY(12px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
